<div *ngIf="warranty?.policy as policy" class="rounded-md">
  <table class="w-full">
    <tbody>
      <ng-container *ngFor="let field of metadataFields$ | async; let last = last">
        <tr>
          <td class="p-2 text-sm font-medium text-gray-700 truncate whitespace-nowrap">{{ field.name }}</td>
          <td class="p-2 text-sm self-center truncate whitespace-nowrap w-full">{{ field.value }}</td>
        </tr>
        <ng-container *ngIf="!last">
          <tr>
            <td colspan="2"><vs-divider></vs-divider></td>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
  </table>
</div>
